/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isBrowser } from 'react-device-detect';
import PropTypes from 'prop-types';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import { SendCryptoScreensFlow } from '../../constants';
import ChecklistOption, { Checklist } from '../../../../components/Checklist';
import Alert from '../../../../components/Alert';
import { GenericLoading } from '../../../../components/Placeholders';
import { useLedgerNotWhitelistedAddresses } from '../../hooks';

const LedgerWalletsWhitelist = ({ openScreen, wallet }) => {
  const { t: translate } = useTranslation();
  const [selectedWallets, updateSelections] = useState([]);
  const [ledgerNotWhitelistedAddresses, isLoading, ledgerError] =
    useLedgerNotWhitelistedAddresses(wallet);

  const nextScreen = () => {
    openScreen(SendCryptoScreensFlow.WHITELIST_VERIFY, {
      isLedgerAddress: true,
      wallets: selectedWallets.map((w) => ({
        ...w,
        coin: wallet.coin,
        // This currency fetched from Ledger and it is causing an issue DV-4176 no need to pass it, replaced with null
        currency: null,
      })),
    });
  };

  const renderTitle = () => (
    <div
      className={`w-100 ${isBrowser ? 'd-flex align-items-center justify-content-between' : ''} `}>
      <div>
        <b className="text-f5 text-dark ms-2">
          {translate('whitelist_address_ledger').replace('%s', wallet?.coin?.toUpperCase())}
        </b>
      </div>
    </div>
  );

  const renderFooter = () => (
    <button
      onClick={nextScreen}
      disabled={selectedWallets.length === 0}
      className="btn btn-primary w-100 mt-auto"
      type="submit">
      {translate('generic_next')}
    </button>
  );

  const onChangeSelections = (value) => {
    updateSelections(value);
  };
  return (
    <ModalBodyLayout
      withBack
      onPrevClick={() => openScreen(SendCryptoScreensFlow.WHITELIST_ADDRESS_TYPE)}
      renderFooter={renderFooter}
      renderTitle={renderTitle}
      title={null}
      isScrollable>
      <div className="d-flex flex-fill flex-column justify-content-start align-content-center h-100">
        <p className="text-f5 my-3">{translate('whitelist_address_ledger_tip')}</p>
        <Alert icon="info" type="info" isClickable={false}>
          {translate('whitelist_address_ledger_info')}
        </Alert>
        <p className="text-f6 text-shadow mt-3 mb-2">
          {translate('whitelist_address_ledger_instruction')}
        </p>
        {ledgerError ? (
          <Alert type="danger" icon="cancel">
            {ledgerError.message}
          </Alert>
        ) : isLoading ? (
          <GenericLoading isFullScreen={false} />
        ) : (
          <div>
            <Checklist onChange={onChangeSelections}>
              {ledgerNotWhitelistedAddresses.map((option) => (
                <ChecklistOption
                  key={option.id}
                  title={option.name}
                  subTitle={option.address}
                  value={option}
                />
              ))}
            </Checklist>
          </div>
        )}
      </div>
    </ModalBodyLayout>
  );
};

export default LedgerWalletsWhitelist;

LedgerWalletsWhitelist.propTypes = {
  openScreen: PropTypes.func.isRequired,
  wallet: PropTypes.shape({
    coin: PropTypes.string.isRequired,
  }).isRequired,
};
